import { WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import {
  QUERY_REQUIREMENT_DEFINITIONS_LIST,
  QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE
} from "../keys";
import {
  listRequirementDefinitions,
  RequirementDefinitionListResponse
} from "../../../services/requirementDefinitions/listRequirementDefinitions";

export const useRequirementDefinitionListSizeQuery = (
  params = {} as any,

  config?: WSQueryConfig<number, WSServiceError>
) => {
  const { sort, filter } = params || {};

  return useWSQuery<number, WSServiceError>(
    [QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE, params],
    async () => {
      const { summary } = await listRequirementDefinitions({
        filter,
        page: { size: 1, number: 1 },
        sort
      });

      return summary.listSize;
    },
    {
      refetchOnMount: false,
      retry: false,
      ...config
    }
  );
};
